import * as XLSX from 'xlsx';
import { FundoListItem } from './mock';
import { FundoForm } from './types';
import { maskCnpj } from './fields';

const COLUNAS: { header: string; get: (f: FundoListItem) => string; width: number }[] = [
  { header: 'CNPJ',          get: (f) => (f.cnpj ? maskCnpj(f.cnpj) : ''), width: 20 },
  { header: 'Razão Social',  get: (f) => f.razao_social, width: 42 },
  { header: 'Nome Fantasia', get: (f) => f.nome_fantasia, width: 28 },
  { header: 'Código ANBIMA', get: (f) => f.codigo_anbima, width: 14 },
  { header: 'Administrador', get: (f) => f.administradora, width: 24 },
  { header: 'Gestor',        get: (f) => f.gestor, width: 24 },
  { header: 'Classe ANBIMA', get: (f) => f.classe_anbima, width: 22 },
  { header: 'Classe ANGA 1', get: (f) => f.classe_anga_1, width: 18 },
  { header: 'Status',        get: (f) => f.status, width: 12 },
  { header: 'Condomínio',    get: (f) => f.condominio, width: 12 },
  { header: 'Conta CETIP',   get: (f) => f.conta_cetip, width: 12 },
  { header: 'Conta SELIC',   get: (f) => f.conta_selic, width: 12 },
];

export function exportarFundosXlsx(fundos: FundoListItem[]): void {
  const linhas = fundos.map((f) => {
    const linha: Record<string, string> = {};
    COLUNAS.forEach((c) => { linha[c.header] = c.get(f) ?? ''; });
    return linha;
  });

  const ws = XLSX.utils.json_to_sheet(linhas, { header: COLUNAS.map((c) => c.header) });
  ws['!cols'] = COLUNAS.map((c) => ({ wch: c.width }));
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: linhas.length, c: COLUNAS.length - 1 } }) };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Fundos');

  const data = new Date().toISOString().slice(0, 10);
  XLSX.writeFile(wb, `fundos_${data}.xlsx`);
}

const condominioLabel = (v?: string): string =>
  v === 'ABERTO' ? 'Aberto' : v === 'FECHADO' ? 'Fechado' : (v ?? '');

// Converte o agregado da tela de detalhe (FundoForm) numa linha igual à da listagem,
// para baixar os dados de um fundo no mesmo formato XLSX da tela de fundos.
export function exportarFundoXlsx(form: FundoForm): void {
  const acharPapel = (papel: string) =>
    form.prestadores.find((p) => p.papel === papel)?.prestador_nome ?? '';
  const acharConta = (tipo: string) =>
    form.contas.find((c) => c.tipo === tipo)?.codigo ?? '';

  const item: FundoListItem = {
    id: 0,
    cnpj: (form.cnpj || '').replace(/\D/g, ''),
    razao_social: form.razao_social ?? '',
    nome_fantasia: form.nome_fantasia ?? '',
    codigo_anbima: form.codigo_anbima ?? '',
    moeda: form.moeda ?? '',
    administradora: acharPapel('ADMINISTRADORA'),
    gestor: acharPapel('GESTORA'),
    classe_anbima: form.classe_anbima_n1 ?? '',
    classe_anga_1: form.classe_anga_1 ?? '',
    status: form.is_active ? 'Ativo' : 'Inativo',
    condominio: condominioLabel(form.classes[0]?.condominio),
    conta_cetip: acharConta('CETIP'),
    conta_selic: acharConta('SELIC'),
    voice: form.voice ?? '',
    juros: form.juros ?? '',
    forma_juridica: form.forma_juridica ?? '',
    data_lancamento: form.data_lancamento ?? '',
  };
  exportarFundosXlsx([item]);
}
